import { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Grid } from '@mui/material';

import { Photo } from '@mui/icons-material';

import ErrorMessage from '../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../sharedModules/layout/LoadingWrapper';
import PageHeader from '../../sharedModules/layout/PageHeader';
import XoiJobPhotosGrid from '../components/XoiJobPhotosGrid';

import XoiJob from '../../developerModules/xoiJobs/model';

import axios from '../../sharedModules/utils/axios.utils';

const PhotoPagesXoiJobDetailPage: FC = () => {
  const { xoiJobId } = useParams<{ xoiJobId: string }>();

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const [xoiJob, setXoiJob] = useState<XoiJob>();

  const fetchXoiJobDetails = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get(`/developers/xoi_jobs/${xoiJobId}`);
      setXoiJob(response.data.result);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchXoiJobDetails();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <ErrorMessage message={errorMessage} />
      </Grid>
      <LoadingWrapper isLoading={loading}>
        <PageHeader
          titleIcon={<Photo />}
          mainTitle={xoiJob?.customer_name}
          subTitle={xoiJob?.work_order_number}
          backButtonLabel="Xoi Jobs"
          backButtonLink="/photo_pages"
        />
      </LoadingWrapper>
      <XoiJobPhotosGrid />
    </Grid>
  );
};

export default PhotoPagesXoiJobDetailPage;
